import MUIDialogContent from '@mui/material/DialogContent'

export const DialogContent = MUIDialogContent
